import React from 'react';
import { connect } from 'react-redux';
import ScrollToTop from 'react-scroll-up';
import FooterSitemap from '../../widgets/FooterSitemap';
import { sanitizedHTML } from '../../utils/Helper';

const PageBottom = (props) => {
  const { siteConfig, i18n } = props;
  const { data = {} } = siteConfig;
  const { sitemapOnFooterInd = false, adGlare_id } = data;
  const { menu_config = {}, page_config = '' } = data[i18n.locale] || {};
  const { page_bottom_content = '' } = page_config;
  const { menu_level_1 = [] } = menu_config;

  const sitemapFooterHTML = sitemapOnFooterInd && <FooterSitemap menuItem={menu_level_1} />;

  console.log(adGlare_id);
  return (
    <div className="PageBottom">
      {/* {page_bottom_content && (
        <div dangerouslySetInnerHTML={{ __html: sanitizedHTML(page_bottom_content) }} />
      )}

      {adGlare_id && (
        <section className="agZone">
          {adGlare_id &&
            adGlare_id
              .toString()
              .split(',')
              .map((v, i) => {
                return <span id={`zone${v}`} key={i} />;
              })}
        </section>
      )}

      {sitemapFooterHTML} */}
      <div className="BackToTopBlock">
        <ScrollToTop showUnder={160} duration={800}>
          <span id="backtotop">UP</span>
        </ScrollToTop>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(PageBottom);

export { PageBottom as PageBottomComponent }; // <- For component Unit Test
export default connectStore;
